import { default as insurCareersTypes } from "./types";

const {
  FETCH_INSUR_CAREERS_REQUEST,
  FETCH_INSUR_CAREERS_SUCCESS,
  FETCH_INSUR_CAREERS_FAILURE,
} = insurCareersTypes;

const initialState = {
  isLoading: false,
  list: [],
  error: "",
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INSUR_CAREERS_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case FETCH_INSUR_CAREERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        list: action.payload,
        error: "",
      };
    case FETCH_INSUR_CAREERS_FAILURE:
      return {
        ...state,
        isLoading: false,
        list: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
